<div class="container mt-5 mx-auto" *transloco="let t; prefix: 'wizard'">
  <div class="flex gap-3 items-center mb-8">
    @if (wizard().backUrl) {
      <p-button
        size="large"
        icon="pi pi-arrow-left"
        text
        severity="contrast"
        (onClick)="confirmBack()"
      ></p-button>
    }
    <div class="text-2xl">{{ t(wizard().title) }}</div>
  </div>
  <p-tabs appTabsUnsavedReveal [(value)]="activeStep">
    <p-tablist>
      @for (step of wizard().steps; track step.index) {
        <p-tab
          [value]="step.index"
          [ngClass]="[stepStyleClass(step.index)]"
          [disabled]="isStepDisabled(step.index)"
        >
          <div>
            <span class="wizard-step-headline">
              {{ t('general.stepLabel', {step: step.index}) }}
            </span>
            <span>{{ t(step.header) }}</span>
          </div>
        </p-tab>
      }
    </p-tablist>
    <p-tabpanels class="mt-10 wizard-step-card">
      @for (step of wizard().steps; track step.index) {
        <p-tabpanel [value]="step.index">
          <div class="flex flex-col p-2.5">
            <div class="flex-auto flex justify-center items-center font-medium">
              <div class="w-full">
                <div class="flex justify-between gap-3 card mb-8! px-6!">
                  <div>
                    <h2 class="text-white text-xl font-bold">
                      {{ t('general.setupHeader', {header: t(step.header)}) }}
                    </h2>
                    <p class="text-gray-400 text-sm mt-2.5">
                      {{ t('general.allFieldsRequired') }}
                    </p>
                  </div>
                  <div class="flex gap-3 pt-2">
                    @if (!isFirstStep) {
                      <p-button
                        label="{{ t('general.goBack') }}"
                        severity="secondary"
                        icon="pi pi-arrow-left"
                        iconPos="left"
                        data-testid="wizard-back-button"
                        (onClick)="prevStep()"
                      />
                    }
                    <p-button
                      label="{{ t('general.saveNext') }}"
                      icon="pi pi-arrow-right"
                      iconPos="right"
                      (onClick)="nextStep()"
                      [disabled]="nextStepDisabled()"
                      data-testid="save-next-button"
                    />
                  </div>
                </div>
                <div class="step-content">
                  @if (activeStep() === step.index) {
                    <ng-container
                      [ngComponentOutlet]="step.content"
                      [ngComponentOutletInputs]="{}"
                      #dynamicOutlet="ngComponentOutlet"
                    >
                    </ng-container>
                  }
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>
